import { render, staticRenderFns } from "./CorendonLoading.vue?vue&type=template&id=23f45712&scoped=true&"
import script from "./CorendonLoading.vue?vue&type=script&lang=js&"
export * from "./CorendonLoading.vue?vue&type=script&lang=js&"
import style0 from "./CorendonLoading.vue?vue&type=style&index=0&id=23f45712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f45712",
  null
  
)

export default component.exports